import { useState } from "react";
import { IoSync } from "react-icons/io5";
import TextboxSearch from "../../components/common/TextboxSearch";
import Toaster from "./../../components/common/Toaster";
import Loader from "./../../components/common/Loader";
import ReferralsTable from "./components/ReferralsTable";
import referralService from "../../services/referralService";

const Referrals = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const columns = [
    { path: "referral_code", label: "Code" },
    { path: "referrer_name", label: "Referrer" },
    { path: "account_name", label: "Referral" },
    { path: "created_on", label: "Date Created" },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  const handleValidate = async () => {
    try {
      setIsLoading(true);

      await referralService.validateReferralsAsync();
      Toaster.Success("Referrals Validated Successfully");
      setIsLoading(false);

      const options = { ...tableOptions };
      handleOptionsChange(options);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-2 max-w-7xl mx-auto px-6 lg:px-0">
      {isLoading && <Loader />}
      <div className="card p-8">
        <div className="block sm:flex justify-between items-center">
          <div>
            <p className="text-gray-400 text-sm">Referrals</p>
            <span className="text-gray-400 text-xs">
              List of Account Referrals
            </span>
          </div>
          <div className="mt-5 sm:mt-0">
            <button
              className="button button-primary"
              onClick={() => handleValidate()}
            >
              <IoSync className="mr-2" />
              Validate Referrals
            </button>
          </div>
        </div>
        <div className="block sm:justify-between items-center mt-8">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
        </div>
        <div className="mt-8">
          <ReferralsTable
            columns={columns}
            tableOptions={tableOptions}
            onChange={handleOptionsChange}
          />
        </div>
      </div>
    </div>
  );
};

export default Referrals;
